import { createContext, useContext, type ReactNode } from "react";

type SidebarItemsContextValue = {
  collapsedItemIds: string[];
  onItemExpandedChange: (itemId: string, isExpanded: boolean) => void;
};

const SidebarItemsContext = createContext<SidebarItemsContextValue | undefined>(undefined);

type SidebarItemsProviderProps = SidebarItemsContextValue & {
  children: ReactNode;
};

export const SidebarItemsProvider = ({
  collapsedItemIds,
  onItemExpandedChange,
  children,
}: SidebarItemsProviderProps) => (
  <SidebarItemsContext.Provider value={{ collapsedItemIds, onItemExpandedChange }}>
    {children}
  </SidebarItemsContext.Provider>
);

export const useSidebarItemExpansion = (itemId: string) => {
  const context = useContext(SidebarItemsContext);
  if (!context) {
    throw new Error("Sidebar menu items must be rendered within <SidebarMenu.Items />");
  }

  const isExpanded = !context.collapsedItemIds.includes(itemId);
  const toggleExpanded = () => context.onItemExpandedChange(itemId, !isExpanded);

  return { isExpanded, toggleExpanded };
};
